/**
 * Client brand configuration.
 * Maps clientId → display name and CDN logo URL.
 *
 * Logo URL convention: {CDN_BASE}/brands/assets/{clientId}/logos/logo-{clientId.toLowerCase()}.png
 */
const CDN_BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets`;
const getLogoUrl = (clientId: string) => `${CDN_BASE}/${clientId}/logos/logo-${clientId.toLowerCase()}.png`;

interface ClientBrand {
  displayName: string;
  logoUrl: string;
}

/**
 * Override map for special cases (e.g. TEST uses MACRO assets during development).
 * Remove or update entries as each client gets their own assets.
 */
const CLIENT_OVERRIDES: Record<string, { displayName: string; logoClientId: string }> = {
  // TEST: { displayName: 'Macro', logoClientId: 'MACRO' },
};

export const getClientBrand = (clientId?: string): ClientBrand | null => {
  if (!clientId) return null;

  const override = CLIENT_OVERRIDES[clientId];
  const displayName = override?.displayName ?? clientId;
  const logoClientId = override?.logoClientId ?? clientId;

  return {
    displayName,
    logoUrl: getLogoUrl(logoClientId)
  };
};
